import { render, staticRenderFns } from "./table_block.vue?vue&type=template&id=b83ba992&scoped=true&lang=pug"
import script from "./table_block.vue?vue&type=script&lang=js"
export * from "./table_block.vue?vue&type=script&lang=js"
import style0 from "./table_block.vue.css?vue&type=style&index=0&id=b83ba992&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83ba992",
  null
  
)

export default component.exports